import styled from "styled-components";

export const OverviewButton = styled.button`
  display: inline-flex; align-items: center; justify-content: center; gap: 6px;
  min-height: 36px; padding: 7px 11px; border-radius: 8px;
  border: 1px solid ${({ $primary }) => $primary ? "#ee754c" : "#e2e8e4"};
  background: ${({ $primary }) => $primary ? "#ee754c" : "#fff"};
  color: ${({ $primary, $danger }) => $primary ? "#fff" : $danger ? "#b55d4a" : "#536a61"};
  font: inherit; font-size: 12px; font-weight: 600; cursor: pointer;
  svg { width: 16px; height: 16px; flex-shrink: 0; stroke-width: 1.75; }
  &:hover:not(:disabled) { background: ${({ $primary }) => $primary ? "#df653d" : "#f5f8f6"}; }
  &:disabled { opacity: .55; cursor: wait; }
`;
export const OverviewRoot = styled.section`
  min-width: 0; color: #344b43; font-size: 13px;
  h3 { font-size: 14px; font-weight: 650; margin: 0; color: #344b43; }
  p { color: #7c8782; font-size: 12px; margin: 5px 0 0; line-height: 1.5; }
`;
export const Controls = styled.div`
  display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between;
  gap: 12px; padding: 14px 0; border-top: 1px solid #edf0ee; border-bottom: 1px solid #edf0ee;
`;
export const Segments = styled.div`
  display: inline-flex; align-items: center; gap: 3px; flex-wrap: wrap;
  button { border: 0; border-radius: 6px; background: transparent; color: #74847c;
    padding: 7px 10px; min-height: 32px; font-size: 12px; font-weight: 500; }
  button[aria-pressed="true"] { color: #c65732; background: #fff1e9; }
  button:hover { background: #f5f7f5; }
`;
export const DateForm = styled.form`
  display: flex; align-items: flex-end; flex-wrap: wrap; gap: 8px;
  label { display: flex; align-items: center; gap: 6px; font-size: 11px; color: #7b867f; }
  input { width: 136px; min-width: 0; min-height: 36px; border: 1px solid #e2e8e4; border-radius: 7px;
    background: #fff; padding: 6px 8px; color: #4f645a; font: inherit; font-size: 12px; }
  @media (max-width: 576px) {
    width: 100%; display: grid; grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) auto;
    label { display: block; } input { display: block; width: 100%; margin-top: 4px; }
  }
`;
export const Metrics = styled.div`
  display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); padding: 22px 0;
  border-bottom: 1px solid #edf0ee; gap: 20px;
  article { min-width: 0; border-right: 1px solid #edf0ee; padding-right: 16px; }
  article:last-child { border-right: 0; }
  header { display: flex; align-items: center; gap: 7px; color: #71837a; font-size: 12px; }
  header svg { width: 16px; height: 16px; color: #8da69a; }
  strong { display: block; font-size: 28px; font-weight: 600; line-height: 1.2; margin: 10px 0 6px; font-variant-numeric: tabular-nums; }
  small { font-size: 11px; color: #7c8782; display: block; }
  @media (max-width: 680px) {
    grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 20px 12px;
    article:nth-child(2) { border-right: 0; } strong { font-size: 25px; }
  }
`;
export const ChartGrid = styled.div`
  display: grid; grid-template-columns: ${({ $equal }) => $equal ? "repeat(2, minmax(0, 1fr))" : "minmax(0, 1.6fr) minmax(0, 1fr)"};
  column-gap: 36px;
  @media (max-width: 1050px) { column-gap: 24px; grid-template-columns: repeat(2, minmax(0, 1fr)); }
  @media (max-width: 760px) { grid-template-columns: minmax(0, 1fr); }
`;
export const Panel = styled.section`
  min-width: 0; padding: 24px 0; border-bottom: 1px solid #edf0ee;
  > header { display: flex; justify-content: space-between; align-items: flex-start; gap: 12px; margin-bottom: 22px; }
  details { margin-top: 12px; color: #71837a; font-size: 11px; }
  summary { cursor: pointer; width: fit-content; }
  details > div { max-height: 220px; overflow: auto; margin-top: 8px; }
  table { width: 100%; font-size: 12px; border-collapse: collapse; }
  th, td { text-align: left; padding: 6px; border-bottom: 1px solid #edf0ee; }
`;
export const State = styled.div`
  display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center;
  min-height: 230px; gap: 12px; padding: 24px; color: #71837a;
  > svg { width: 30px; height: 30px; color: #a0b4a9; }
  strong { color: #4f665a; font-weight: 600; }
`;
